import { Component, OnInit, ViewEncapsulation, Inject } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { Role, Module } from "../../shared/interface/role";
import { Site } from "../../shared/interface/site";
import { Zone } from "../../shared/interface/zone";
import { Dashboard } from "../../shared/interface/dashboard";
import { RoleService } from "../../shared/services/role/role.service";
import { SiteService } from "../../shared/services/site/site.service";
import { ZoneService } from "../../shared/services/zone/zone.service";
import { DashboardService } from "../../shared/services/dashboard/dashboard.service";
import { Observable } from "rxjs/Observable";
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
  FormArray
} from "@angular/forms";

@Component({
  selector: "app-roles",
  templateUrl: "./roles.component.html",
  styleUrls: ["./roles.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class RolesComponent implements OnInit {
  dataSource;
  constructor(public dialog: MatDialog, private roleService: RoleService) { }

  ngOnInit() {
    this.setList();

    this.roleService.getAction().subscribe(data => {
      if (["create", "update"].includes(data.action)) {
        this.setList();
      }
    });
  }

  setList() {
    this.roleService.list().subscribe(r => {
      this.dataSource = r;
      if (Array.isArray(r) && r.length > 0) {
        for (let i = 0; i < r.length; i++) {
          let mapped = [];
          if (r[i]["modules"] && r[i]["modules"].length > 0) {
            for (let p = 0; p < r[i]["modules"].length; p++) {
              mapped.push(r[i]["modules"][p]["name"]);
            }
          }
          this.dataSource[i]["mapped"] = mapped.join();
        }
      }
    });
  }

  delete(id) {
    if (
      confirm(
        "Are you sure you want to remove this role. Note: Associated user would not have access"
      ) == false
    ) {
      return false;
    }

    let temp = this.dataSource;
    this.dataSource = this.dataSource.filter(item => item["_id"] !== id);
    this.roleService.delete(id).subscribe(
      r => { },
      e => {
        this.dataSource = temp;
      }
    );
  }

  openRoleDialog(data = {}) {
    this.dialog.open(RoleDialog, {
      data: data,
      height: "auto",
      width: "800px",
      panelClass: "full-modal"
    });
  }
}

@Component({
  selector: "role-dialog",
  templateUrl: "role.dialog.html"
})
export class RoleDialog {
  roleForm: FormGroup;
  modules: Module[] = [];
  isSubmitted: number = 0;
  allAccess = {
    name: "all",
    selected: false,
    grantPermission: "read",
    on: "all"
  };
  accessModuleItemList = {
    "sites": [],
    "zones": [],
    "full-zones": [],
    "private-dashboard": [],
  }
  moduleNames = [
    "users",
    "roles",
    "sites",
    "zones",
    "brands",
    "devices",
    "subscriptions",
    "private-dashboard",
    "events",
    "alerts",
    "support"
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private roleService: RoleService,
    private siteService: SiteService,
    private zoneService: ZoneService,
    private dashboardService: DashboardService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<RoleDialog>
  ) { }

  ngOnInit() {
    this.data = this.parseData(this.data);
    this.createForm(this.data);
    this.siteService.list("fields=siteName").subscribe((res: any) => {
      res = res.map(r => { r.name = r.siteName; return r; });
      this.accessModuleItemList["sites"] = res;
    })

    this.zoneService.list("fields=zoneName,siteId").subscribe((res: any) => {
      res = res.map(r => { r.name = r.siteName + '::' + r.zoneName; return r; });
      this.accessModuleItemList["zones"] = res;
      this.accessModuleItemList["full-zones"] = res;
    })

    this.dashboardService.list().subscribe((res: any) => {
      res = res.map(r => { r.name = r.dashboardName; return r; });
      this.accessModuleItemList["private-dashboard"] = res;
    })
  }

  createForm(data: Role) {
    this.roleForm = this.fb.group({
      _id: [data._id],
      roleName: [data.roleName, Validators.required],
      all: this.fb.group(this.allAccess),
      modules: this.fb.array([])
    });

    this.setModules(data.modules);
  }

  parseData(data): Role {
    let selected = false;
    let grantPermission = "read";
    let on = ["all"];
    if (!(data && data.modules && data.modules.constructor == Array)) {
      data.modules = [];
    }

    this.moduleNames.forEach(m => {
      selected = false;
      grantPermission = "read";
      on = ["all"];
      data.modules.forEach(am => {
        if (this.allAccess.name == am.name) {
          this.allAccess.selected = true;
          this.allAccess.grantPermission = am.grantPermission;
        }
        if (am.name == m) {
          selected = true;
          grantPermission = am.grantPermission;
          on = am.on;
        }
      });

      let obj = {
        name: m,
        selected: selected,
        grantPermission: grantPermission,
        on: on
      };
      this.modules.push(obj);
    });

    if (data && data.roleName && data.modules) {
      return data;
    }
    data = {
      _id: "",
      roleName: "",
      created: "",
      modules: this.modules
    };
    return data;
  }

  setModules(modules: any) {
    let m = this.modules.map(m => {
      m.on = [m.on]
      return this.fb.group(m);
    });
    let modulesA = this.fb.array(m);
    this.roleForm.setControl("modules", modulesA);
  }

  getModules() {
    return <FormArray>this.roleForm.get('modules');
  }

  getModuleByName(mn) {
    let m = {
      name: "",
      selected: false,
      grantPermission: "",
      on: [],
    };
    let modules = this.getModules().value;
    modules.forEach(o => {
      if (o.name == mn) {
        m = o;
      }
    })
    return m;
  }

  getAccessModuleItemList(name: string) {
    let items = []
    if (this.accessModuleItemList[name]) {
      items = this.accessModuleItemList[name];
    }
    return items;
  }

  // updateModuleItemList(e, mn){
  //   let modules = this.getModules();
  //   let mv = modules.value;
  //   mv.forEach((m,i) => {
  //     if(mn == "sites"){
  //       //set filtered zone if site is selected
  //       this.accessModuleItemList["zones"] = this.accessModuleItemList["full-zones"].filter(z => m.on.includes(z.siteId) || m.on[0] == "all");
  //     }

  //     //if all selected add all
  //     //if any on unselected other than all set all unselect
  //     if(mn == m.name){
  //       let ami = this.getAccessModuleItemList(mn);
  //       if(ami.length == m.on.length && m.on[0] == 'all'){
  //         m.on = m.on.filter(o => o != 'all')
  //       }else if(ami.length == m.on.length && m.on[0] != 'all'){
  //         m.on = ['all', ...m.on]
  //       }
  //       modules.get(i+".on").setValue(m.on);
  //     }
  //   });
  // }

  // selectAllModuleItem(mn, isAll=false){
  //   let modules = this.getModules();
  //   let mv = modules.value;
  //   mv.forEach((m,i) => {
  //     if(mn == m.name){
  //       if(isAll){
  //         let ami = this.getAccessModuleItemList(mn);
  //         if(m.on[0] != 'all' || (ami.length + 1) == m.on.length){
  //           m.on = [];
  //         }else{
  //           let ml = this.getAccessModuleItemList(mn).map(d => d._id);
  //           m.on = ['all', ...ml];
  //         }
  //         modules.get(i+".on").setValue(m.on);
  //       }
  //     }
  //   })
  // }


  updateModuleItemList(e, mn) {
    let modules = this.getModules();
    let mv = modules.value;
    mv.forEach((m, i) => {
      if (mn == "sites" && m.name == mn) {
        //set filtered zone if site is selected
        this.accessModuleItemList["zones"] = this.accessModuleItemList["full-zones"].filter(z => m.on.includes(z.siteId) || m.on[0] == "all");
      }
    });
  }

  selectAllModuleItem(mn, isAll = false) {
    let modules = this.getModules();
    let mv = modules.value;
    mv.forEach((m, i) => {
      if (mn == m.name) {
        if (isAll) {
          if (m.on.indexOf('all') > -1) {
            let temp = ['all', ...this.accessModuleItemList[mn].map((x) => { return x._id })];
            m.on = temp
          }
          else {
            m.on = [];
          }
        } else {
          m.on = m.on.filter(o => o != 'all');
          if (m.on.length === this.accessModuleItemList[mn].length)
            m.on.push('all');
        }
        modules.get(i + ".on").setValue(m.on);
      }
    });
  }

  onSubmit(form: any) {
    if (!this.roleForm.valid) {
      return false;
    }
    this.isSubmitted = 1;
    let roleName = form.roleName;
    let modules = [];

    if (form.all.selected) {
      let object = {
        name: form.all.name,
        grantPermission: form.all.grantPermission,
        on: "all"
      };
      modules.push(object);
    }

    if (modules.length == 0) {
      for (let i = 0; i < form.modules.length; i++) {
        if (
          form.modules[i].name !== "" &&
          form.modules[i].grantPermission !== "" &&
          form.modules[i].selected
        ) {
          let object = {
            name: form.modules[i].name,
            grantPermission: form.modules[i].grantPermission,
            on: form.modules[i].on
          };
          modules.push(object);
        }
      }
    }

    let body: any = {
      roleName: roleName,
      modules: modules
    };

    if (form._id == "") {
      this.roleService.create(body).subscribe(r => {
        this.roleService.sendAction("create", {});
        this.dialogRef.close();
        this.isSubmitted = 0;
      }, err => {
        this.isSubmitted = 0;
      });
    } else {
      body.roleId = form._id;
      this.roleService.update(body).subscribe(r => {
        this.roleService.sendAction("update", {});
        this.dialogRef.close();
        this.isSubmitted = 0;
      }, err => {
        this.isSubmitted = 0;
      });
    }
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/profile/roles/roles.component.ts